<template>
  <div>

    <md-field md-clearable class="md-toolbar-section-end">
      <md-input placeholder="Search" v-model="search" @input="searchOnTable" />
    </md-field>
    <md-table v-model="searched" :table-header-color="tableHeaderColor">
      <md-table-empty-state
        md-label="No users found"
        :md-description="`No user found for this '${search}' query. Try a different search term or create a new user.`">
      </md-table-empty-state>

      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="Name">{{ item.user_profile ? item.user_profile.name: ""}}</md-table-cell>
        <md-table-cell md-label="Phone">{{ item.phone_number }}</md-table-cell>
        <md-table-cell md-label="Gender">{{ item.user_profile ? item.user_profile.gender.gender : "" }}</md-table-cell>
        <md-table-cell md-label="Created">{{ item.created_at.date }}</md-table-cell>
        <md-table-cell md-label="Action"><button class="buttonEdit" @click="editFinder(item)"><span><i class="fa fa-edit"></i> </span></button><button class="buttonDelete" @click="deleteFinder(item)"><span><i class="fa fa-trash"></i></span></button></md-table-cell>
      </md-table-row>
    </md-table>
    <md-dialog :md-active.sync="edit" style="width: auto">
      <md-dialog-title>Edit Finder</md-dialog-title>
      <div class="md-layout" style="width: 70%; margin: 10px auto; height:100%;">
        <md-field>
          <label>Name</label>
          <md-input v-model="name"></md-input>
        </md-field>

        <md-field>
          <label>Phone</label>
          <md-input v-model="phone" maxlength="30" disabled></md-input>
        </md-field>

        <!--<md-field :md-counter="false">
          <label>Gender</label>
          <md-input v-model="gender" maxlength="10"></md-input>
        </md-field>
-->
        <md-field>
          <label>Gender</label>

          <md-select v-model="genderUser">
            <md-option v-for="(blood, operator) in gender" :key="operator" :value="blood.id">{{blood.gender}}</md-option>
          </md-select>
        </md-field>
        <md-field>
          <label>Created</label>
          <md-input v-model="created" md-autogrow maxlength="30" disabled></md-input>
        </md-field>
      </div>
      <md-dialog-actions>
        <md-button class="md-primary" @click="edit = false">Close</md-button>
        <md-button class="md-primary" @click="edit = false">Update</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog :md-active.sync="deleteitem"  style="width: 50%">
      <md-dialog-title>Delete Donor</md-dialog-title>
      <div style="width: 70%; margin: 10px auto">
        <i class="fa fa-trash" style="margin-left: -5%; font-size: 34px"></i>
        <span style="margin-left: 5%;font-size: 20px">Are you sure?</span>
      </div>
      <md-dialog-actions>
        <md-button class="md-primary" @click="deleteitem = false">Close</md-button>
        <md-button class="md-primary" @click="deleteitem = false">Delete</md-button>
      </md-dialog-actions>

    </md-dialog>
  </div>
</template>

<script>
  const toLower = text => {
    return text.toString().toLowerCase()
  }

 /* const searchByNumber = (items, term) => {
    let newArray = []
    if (term) {
    items = items.filter(item => {
        if(item) {
          toLower(item.phone_number).includes(term)
        }
      })
    }
    return items
  }*/
  var moment = require('moment');
  export default {
    name: 'simple-table',
    props: {
      tableHeaderColor: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        search: null,
        searched: [],
        selected: [],
        usersList: [],
        edit:false,
        deleteitem: false,
        name:'',
        phone:'',
        gender:[],
        curentFinder:'',
        genderUser: 0,
        created:''
      }
    },
    beforeMount: function () {
      this.$store.dispatch('GetUserList').then((response)=> {
        console.log('show', response.data.data);
        this.usersList = response.data.data;
        this.usersList.forEach((request)=>{
          request.created_at.date = moment(request.created_at.date).format('YYYY-MM-DD')
        })
        this.searched = this.usersList
      });
      this.$store.dispatch('GetGender').then((response) => {
        this.gender = response.data.data;
      })
    },
    methods:{

      searchOnTable () {
       // this.searched = searchByName(this.usersList, this.search)
        this.searched = this.usersList.filter(item => {
          if(item) {
             if( toLower(item.phone_number).includes(this.search) || toLower(item.user_profile.name).includes(this.search) || toLower(item.user_profile.gender.gender).includes(this.search)){

               return item
             }
          }
        })

        if(this.searched.length<1){
        }

      },
      editFinder(finder){
        this.curentFinder = finder
        this.edit = true;
        this.name = finder.user_profile ? finder.user_profile.name: "";
        this.phone = finder.phone_number;
        /*this.gender = finder.user_profile ? finder.user_profile.gender.gender : ""*/
        this.genderUser = this.gender.find(gen => gen.id === finder.user_profile.gender.id).id;
        console.log(finder.user_profile.gender.id)
        this.created = finder.created_at.date;
      },
      deleteFinder(donor){
        this.deleteitem= true
      }
    },
    // created () {
    //   this.searched = this.users
    // }
  }
</script>
<style>
  .md-dialog{
    transform: translate3d(-305px, -325px, 0px) scale(1) !important;
    max-height: 100% !important;
  }
  @media only screen and (max-width: 600px) {
    .md-dialog{
      transform: none !important;
      max-height: 75% !important;
    }
    .md-layout{
      overflow-y: scroll !important;
    }
  }
</style>
